/**
 *  @class
 *  @function  Blog
 */

class Blog {
	constructor() {
		this.select = Array.from(document.querySelectorAll('.blog-header--tags-select'));
		this.setupEventListeners();
	}
	setupEventListeners() {
		this.select.forEach(select => select.addEventListener('change', this.onChange));
	}
	onChange(event) {
		window.location.href = this.value;
	}
}
window.addEventListener('load', () => {
	if (typeof Blog !== 'undefined') {
		new Blog();
	}
});